import { EventEmitter, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NetworkHelper } from '../helpers';
import { Observable } from 'rxjs';
import { SHARED_ENV } from '../tokens';

@Injectable()
export class MaintenanceService {
  private readonly env = inject(SHARED_ENV);
  public hostUrl: string;

  maintenanceChange = new EventEmitter();

  constructor(private router: Router, private networkHelper: NetworkHelper) {
    this.hostUrl = this.env.host;
  }

  updateConfiguration(data: any): Observable<any> {
    return this.networkHelper.post(`${this.hostUrl}/maintenance`, data);
  }

  getAll(
    page: number,
    itemsPerPage: number,
    status: string,
    keyword?: string
  ): Observable<any> {
    const data: any = {
      page: page,
      itemsPerPage: itemsPerPage,
      status: status,
      keyword: keyword,
    };
    return this.networkHelper.get(`${this.hostUrl}/maintenance/all`, data);
  }

  getMaintenance(): Observable<any> {
    return this.networkHelper.get(`${this.hostUrl}/maintenance/status`);
  }

  getMaintenanceById(id: string): Observable<any> {
    return this.networkHelper.get(`${this.hostUrl}/maintenance/${id}`);
  }
}
